import React, { useState } from 'react'
import get from 'lodash.get'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { useMutation, useQuery } from 'react-query'
import { Button, Card, Image, Modal, Radio, Select, Space, Form as StyleForm, Typography } from 'antd'
import { formOptions } from '../../../forms/blocks'
import { adjustmentInfos } from '../../../forms/blocks/Adjustment'
import { getClientDetails } from '../../../network/Clients'
import { getOrderExcel, getAdjustmentExcel, updateOrder, updateProductCompletionStatus } from '../../../network/Orders'
import { getProductDetailsComplete } from '../../../network/Products'
import { getCurrencySymbol } from '../../../utils/currencyUtils'
import { getFromKey, getCollectFrom, getCollectFromForm, getFixedDesignCategory } from '../utils/orderHelpers'
import { PRIORITY_MAP } from '../../../utils/utils'

const { Text, Title } = Typography

const resolveProductName = (name) => {
  if (!name) return ''
  if (typeof name === 'string') return name
  return name.en || name.zh || ''
}

const AdjustmentCard = ({ product, measureSelected, onCompletionStatusChange }) => {
  return (
    <>
      <Card
        style={{ width: '100%' }}
        title={`Adjustment ${
          adjustmentInfos[get(product, `orderAdjustment.type`, 'vest')].name
        }`}
      >
        {adjustmentInfos[
          get(product, `orderAdjustment.type`, 'vest')
        ].forms.map((fff) =>
          fff.form.map((form) =>
            form.sections.map((section) =>
              section.canAdd
                ? get(product, `orderAdjustment.adjustmentPositions`, []).map(
                    (adj, idex) => [
                      <>
                        <Text underline key={`title${idex}`}>
                          <strong>{`${section.display} ${idex + 1}`}</strong>
                        </Text>
                        <br />
                      </>,
                      section.fields.map((field) => {
                        const value = get(adj, field.key.join('.'), '')

                        if (
                          (field.isHiding &&
                            field.isHiding(
                              product,
                              `orderAdjustment.adjustmentPositions.${idex}.`
                            )) ||
                          (!value && value !== 0)
                        ) {
                          return null
                        }

                        return (
                          <>
                            <Text key={`${field.key.join('.')}${idex}`}>
                              <strong>{field.label}: </strong>
                              {field.type === 'multiupload'
                                ? [
                                    <br />,
                                    value?.map((pic) => (
                                      <Image
                                        // width={125}
                                        height={100}
                                        src={`${process.env.REACT_APP_API_URL}${field.storageURI}/${pic.uri}`}
                                      />
                                    )),
                                  ]
                                : value}
                            </Text>
                            <br />
                          </>
                        )
                      }),
                    ]
                  )
                : section.fields.map((field) => {
                    const value = get(
                      product,
                      `orderAdjustment.${field.key.join('.')}`,
                      ''
                    )

                    if (
                      (field.isHiding &&
                        field.isHiding(product, `orderAdjustment.`)) ||
                      (!value && value !== 0)
                    ) {
                      return null
                    }

                    return (
                      <>
                        <Text key={field.key.join('.')}>
                          <strong>{field.label}: </strong>
                          {field.type === 'multiupload'
                            ? [
                                <br />,
                                value?.map((pic) => (
                                  <Image
                                    height={100}
                                    src={`${process.env.REACT_APP_API_URL}${field.storageURI}/${pic.uri}`}
                                  />
                                )),
                              ]
                            : Array.isArray(value)
                            ? value.join(', ')
                            : value}
                        </Text>
                        <br />
                      </>
                    )
                  })
            )
          )
        )}
      </Card>
      <Card style={{ width: '100%', marginTop: -1 }}>
        <Space direction="vertical">
          <Text type="secondary">
            QTY:{' '}
            {get(product, `orderAdjustment.adjustmentPositions`, []).length}
          </Text>
          <Text strong>¥{get(product, `orderAdjustment.price`, 0)}</Text>
          <Space>
            <Select
              value={get(product, 'completionStatus', 'in_production')}
              style={{ width: 180 }}
              onChange={(value) =>
                onCompletionStatusChange(
                  get(product, '_id'),
                  get(product, 'completionStatus', 'in_production'),
                  value
                )
              }
            >
              <Select.Option value="in_production">In production</Select.Option>
              <Select.Option value="given_to_client">Given to client</Select.Option>
              <Select.Option value="ready_to_pick_up">Ready to pick up</Select.Option>
            </Select>
          </Space>
          <Space>
            <Button type="primary" onClick={measureSelected}>
              Modify
            </Button>
          </Space>
        </Space>
      </Card>
    </>
  )
}


const CollectionSizeOrOptions = ({ product }) => {
  const size = product?.orderCollection?.size
  if (size != null) {
    const sizeName =
      typeof size === 'object' && size?.name
        ? size.name?.en || size.name?.zh || size.value
        : size
    return (
      <Text>
        <strong>Size: </strong>
        {sizeName}
      </Text>
    )
  }
  if (product?.orderCollection?.options?.length) {
    return (
      <>
        {product.orderCollection.options.map((option) => {
          const selectedOption = option?.subOptions?.find((sub) => sub.selected)
          return (
            <React.Fragment key={option._id}>
              <Text>
                <strong>{option?.name?.en || option?.name?.zh}: </strong>
                {selectedOption?.name?.en || selectedOption?.name?.zh}
              </Text>
              <br />
            </React.Fragment>
          )
        })}
      </>
    )
  }
  return <Text>No size / options</Text>
}


const OptionDisplay = ({ formsInf, product }) => {
  return formsInf.map((forms, formsIdx) => (
    <React.Fragment key={forms.key ?? `forms-${formsIdx}`}>
      {forms.form.map((e, eIdx) => (
        <React.Fragment key={e.display ?? `e-${eIdx}`}>
          {e.sections?.map((section, sectionIdx) =>
            section.canAdd && section.key.includes('extraShirts')
              ? get(product, `${forms.key}.${section.key.join('.')}`, [])?.map(
                  (extraShirt, idex) => (
                    <React.Fragment
                      key={`${section.key?.join('.')}-${idex}`}
                    >
                      <Text underline>
                        <strong>{`${section.display} ${idex + 1}`}</strong>
                      </Text>
                      <br />
                      {section.fields.map((field) => {
                        let value = get(extraShirt, field.key.join('.'), '')

                        if (
                          (field.isHiding &&
                            field.isHiding(
                              product,
                              `${forms.key}.${section.key.join('.')}.${idex}.`
                            )) ||
                          (!value && value !== 0)
                        ) {
                          return null
                        }

                        // For price field in extraShirts: display as Quality
                        if (
                          section.key.includes('extraShirts') &&
                          field.key?.[0] === 'price' &&
                          field.onChangeRef
                        ) {
                          return (
                            <React.Fragment
                              key={`${field.key.join('.')}-${idex}`}
                            >
                              <Text>
                                <strong>Quality: </strong>
                                {value}
                              </Text>
                              <br />
                            </React.Fragment>
                          )
                        }

                        // For priceNum field in extraShirts: display as Price
                        if (
                          section.key.includes('extraShirts') &&
                          field.key?.[0] === 'priceNum'
                        ) {
                          return (
                            <React.Fragment
                              key={`${field.key.join('.')}-${idex}`}
                            >
                              <Text>
                                <strong>Price: </strong>
                                {value}
                              </Text>
                              <br />
                            </React.Fragment>
                          )
                        }

                        if (!field.label) return null

                        if (field.onChangeRef) {
                          value =
                            value +
                            ' ' +
                            get(extraShirt, field.onChangeRef.join('.'), '')
                        }

                        return (
                          <React.Fragment
                            key={`${field.key.join('.')}-${idex}`}
                          >
                            <Text>
                              <strong>{field.label}: </strong>
                              {value}
                            </Text>
                            <br />
                          </React.Fragment>
                        )
                      })}
                    </React.Fragment>
                  )
                )
              : section.fields.map((g) => {
                  const value = get(
                    product,
                    `${forms.key}.${g.key.join('.')}`,
                    ''
                  )

                  if (g.isOldField && !value) {
                    return null
                  }

                  if (
                    (g.isHiding && g.isHiding(product, `${forms.key}.`)) ||
                    (!value && value !== 0)
                  ) {
                    return null
                  }

                  return (
                    <React.Fragment key={g.key.join('.')}>
                      <Text>
                        <strong>{g.label}: </strong>
                        {Array.isArray(value) ? value.join(', ') : value}
                      </Text>
                      <br />
                    </React.Fragment>
                  )
                })
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  ))
}


const MeasureCard = ({ product, measureSelected, validated, orderDetails, onCompletionStatusChange }) => {
  const [selectedMeasure, setSelectedMeasure] = useState('0')
  const isCollection = getFromKey(product) === 'collection'
  const isFixedDesign = getFromKey(product) === 'fixed_design'
  const productDetails = useQuery(
    [
      'getProductDetailsComplete',
      {
        id: get(product, 'orderCollection.product', ''),
      },
    ],
    getProductDetailsComplete,
    {
      refetchOnWindowFocus: false,
      enabled: isCollection,
    }
  )

  // if (!product.skuMeasurements?.length) {
  //   return null
  // }

  const calcTotal = () => {
    const type = getFromKey(product)

    switch (type) {
      case 'collection':
        return get(product, `orderCollection.price`, 0)
      case 'adjustment':
        return get(product, `orderAdjustment.price`, 0)
      case 'fixed_design':
        return get(product, `orderFixedDesign.price`, 0)
      default:
        let price = get(product, `orderCustom.price`, 0)
        let extraShirts = get(
          product,
          `orderCustom.orderCustomShirt.extraShirts`,
          []
        )
        if (extraShirts) {
          extraShirts.forEach((item) => {
            price += get(item, 'priceNum', 0)
          })
        }
        return price
    }
  }

  const getQty = () => {
    const type = getFromKey(product)

    switch (type) {
      case 'collection':
        return get(product, `orderCollection.quantity`) || 1
      case 'adjustment':
        return get(product, `orderAdjustment.addMore`, 0) + 1
      case 'fixed_design':
        return 1
      default:
        let addMore = get(product, `orderCustom.addMore`, 0) + 1
        let extraShirts = get(
          product,
          `orderCustom.orderCustomShirt.extraShirts`,
          []
        )
        let extraShirtsCount = extraShirts ? extraShirts.length : 0
        return addMore + extraShirtsCount
    }
  }

  const categoryForForms =
    isFixedDesign ? getFixedDesignCategory(product) : getFromKey(product)
  const prodForms = formOptions[categoryForForms]
  const formsInf = isCollection
    ? getCollectFrom(get(productDetails, 'data.category.blocks', []))
    : prodForms?.measuresForms

  const formsInfF = isCollection
    ? getCollectFromForm(get(productDetails, 'data.category.blocks', []))
    : prodForms?.forms

  let symbol = ''
  if (orderDetails.currency) {
    symbol = getCurrencySymbol(orderDetails.currency)
  }

  return (
    <>
      {validated ? (
        <Card
          style={{ width: '100%' }}
          title={
            isCollection
              ? `Fixed SKU: ${
                  resolveProductName(get(product, 'orderCollection.productName')) ||
                  get(productDetails, 'data.name.en', '')
                }`
              : isFixedDesign
              ? `Fixed Design: ${
                  resolveProductName(get(product, 'orderFixedDesign.productName'))
                }`
              : prodForms?.name
          }
           tabList={
            product.skuMeasurements
              ? [
                  { key: 'opt', tab: 'Options' },
                  ...product.skuMeasurements.map((e, i) => ({
                    key: `${i}`,
                    tab: `Measurement after adjustment ${i + 1}`,
                  })),
                ]
              : []
          }

          activeTabKey={selectedMeasure}
          onTabChange={setSelectedMeasure}
        >
          {/* <Space direction="vertical"> */}
          {selectedMeasure === 'opt' ? (
            product.orderProductType === 'collection' ? (
              product.orderCollection.size != null ? (
                (() => {
                  const size = product.orderCollection.size
                  const sizeName =
                    typeof size === 'object' && size?.name
                      ? size.name?.en || size.name?.zh || size.value
                      : size
                  return (
                    <Text>
                      <strong>Size: </strong>
                      {sizeName}
                    </Text>
                  )
                })()
              ) : product.orderCollection.options ? (
                product.orderCollection.options.map((option, i) => {
                  const optionName = option?.subOptions?.find(
                    (e) => e.selected
                  )?.name
                  return (
                    <Text key={i}>
                      <strong>{option?.name?.en || option?.name?.zh}: </strong>
                      {optionName?.en || optionName?.zh}
                    </Text>
                  )
                })
              ) : (
                <Text>No size / options</Text>
              )
            ) : product.orderProductType === 'fixed_design' ? (
              <>
                {get(product, 'orderFixedDesign.description') && (
                  <>
                    <Text>
                      <strong>Description: </strong>
                      {get(product, 'orderFixedDesign.description.en', '') ||
                        get(product, 'orderFixedDesign.description.zh', '')}
                    </Text>
                    <br />
                  </>
                )}
                {get(product, 'orderFixedDesign.selectedOptions', []).length >
                0 ? (
                  get(product, 'orderFixedDesign.selectedOptions', []).map(
                    (option, i) => (
                      <React.Fragment key={i}>
                        <Text>
                          <strong>
                            {option?.optionName?.en || option?.optionName?.zh}:{' '}
                          </strong>
                          {option?.freeFieldValue ||
                            option?.subOptionName?.en ||
                            option?.subOptionName?.zh}
                        </Text>
                        <br />
                      </React.Fragment>
                    )
                  )
                ) : (
                  <Text>No Options</Text>
                )}
              </>
            ) : (
              formsInfF?.map((forms, formsIdx) => (
                <React.Fragment key={forms.key ?? `forms-${formsIdx}`}>
                  {forms?.form?.map((e, eIdx) => (
                    <React.Fragment key={e.display ?? `e-${eIdx}`}>
                      {e.display ? (
                        <Title level={5}>{e.display}:</Title>
                      ) : null}
                      {e.sections?.map((section, sectionIdx) =>
                        section.canAdd && section.key.includes('extraShirts')
                          ? get(
                              product,
                              `${forms.key}.${section.key.join('.')}`,
                              []
                            )?.map((extraShirt, idex) => (
                              <React.Fragment
                                key={`${section.key?.join('.')}-${idex}`}
                              >
                                <Text underline>
                                  <strong>{`${section.display} ${
                                    idex + 1
                                  }`}</strong>
                                </Text>
                                <br />
                                {section.fields.map((field) => {
                                  let value = get(
                                    extraShirt,
                                    field.key.join('.'),
                                    ''
                                  )

                                  if (
                                    (field.isHiding &&
                                      field.isHiding(
                                        product,
                                        `${forms.key}.${section.key.join(
                                          '.'
                                        )}.${idex}.`
                                      )) ||
                                    (!value && value !== 0)
                                  ) {
                                    return null
                                  }

                                  // For price field in extraShirts: display as Quality (the key), don't combine with priceNum
                                  if (
                                    section.key.includes('extraShirts') &&
                                    field.key?.[0] === 'price' &&
                                    field.onChangeRef
                                  ) {
                                    return (
                                      <React.Fragment
                                        key={`${field.key.join('.')}-${idex}`}
                                      >
                                        <Text>
                                          <strong>Quality: </strong>
                                          {value}
                                        </Text>
                                        <br />
                                      </React.Fragment>
                                    )
                                  }

                                  // For priceNum field in extraShirts: display as Price
                                  if (
                                    section.key.includes('extraShirts') &&
                                    field.key?.[0] === 'priceNum'
                                  ) {
                                    return (
                                      <React.Fragment
                                        key={`${field.key.join('.')}-${idex}`}
                                      >
                                        <Text>
                                          <strong>Price: </strong>
                                          {value}
                                        </Text>
                                        <br />
                                      </React.Fragment>
                                    )
                                  }

                                  if (!field.label) return null

                                  // For other fields with onChangeRef, combine as before
                                  if (field.onChangeRef) {
                                    value =
                                      value +
                                      ' ' +
                                      get(
                                        extraShirt,
                                        field.onChangeRef.join('.'),
                                        ''
                                      )
                                  }

                                  return (
                                    <React.Fragment
                                      key={`${field.key.join('.')}-${idex}`}
                                    >
                                      <Text>
                                        <strong>{field.label}: </strong>
                                        {value}
                                      </Text>
                                      <br />
                                    </React.Fragment>
                                  )
                                })}
                              </React.Fragment>
                            ))
                          : section.fields?.map((g) => {
                              let value = get(
                                product,
                                `${forms.key}.${g.key.join('.')}`,
                                ''
                              )
                              if (
                                (g.isHiding &&
                                  g.isHiding(product, `${forms.key}.`)) ||
                                (!value && value !== 0)
                              ) {
                                return null
                              }

                              if (g.options && Array.isArray(g.options)) {
                                const val = g.options.find(
                                  (item) => item.key === value
                                )
                                if (val && val.label) {
                                  value = val.label
                                }
                              }

                              return (
                                <React.Fragment key={g.key.join('.')}>
                                  <Text>
                                    <strong>{g.label}: </strong>
                                    {Array.isArray(value)
                                      ? value.join(', ')
                                      : value}
                                  </Text>
                                  <br />
                                </React.Fragment>
                              )
                            })
                      )}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))
            )
          ) : (
            formsInf?.map((froms, fromsIdx) => (
              <React.Fragment key={froms.key ?? `froms-${fromsIdx}`}>
                {froms?.form?.map((e, eIdx) => (
                  <React.Fragment key={e.display ?? `e-${eIdx}`}>
                    <Title level={5}>{e.display}:</Title>
                    {/* Show size preset metadata if present (validated orders, per-measurement tab) */}
                    {(() => {
                      const measKey = froms.key.replace('0', `${selectedMeasure}`)
                      const meta = get(
                        product,
                        `${measKey}.__sizePresetMeta`,
                        null
                      )
                      if (!meta || !meta.presetName || !meta.sizeName) return null
                      return (
                        <>
                          <Text>
                            <strong>Preset size: </strong>
                            {meta.presetName} – {meta.sizeName}
                          </Text>
                          <br />
                        </>
                      )
                    })()}
                    {e.sections?.map((f, fIdx) => (
                      <React.Fragment key={f.key?.join('.') ?? fIdx}>
                        {f.fields?.map((g) => {
                          const basePath = froms.key.replace(
                            '0',
                            `${selectedMeasure}`
                          )
                          const fullPath = `${basePath}.${g.key.join('.')}`
                          const value = get(product, fullPath, '')

                          if (!g.label) return null

                          const isTrialSamplePicture =
                            g.key.join('.') === 'trialSamplePicture'

                          // Skip complex objects except trialSamplePicture
                          if (typeof value === 'object' && !isTrialSamplePicture)
                            return null

                          if (
                            (g.isHiding &&
                              g.isHiding(product, `${basePath}.`, true)) ||
                            (!value && value !== 0)
                          ) {
                            return null
                          }

                          if (isTrialSamplePicture) {
                            const pics = Array.isArray(value) ? value : []
                            if (!pics.length) return null

                            return (
                              <React.Fragment key={g.key.join('.')}>
                                <Text>
                                  <strong>{g.label}: </strong>
                                </Text>
                                <br />
                                <Space wrap style={{ marginBottom: 8 }}>
                                  {pics.map((pic, idx) => (
                                    <Image
                                      key={idx}
                                      height={100}
                                      src={`${process.env.REACT_APP_API_URL}/storage/order-trial-sample/${pic.uri}`}
                                    />
                                  ))}
                                </Space>
                                <br />
                              </React.Fragment>
                            )
                          }

                          return (
                            <React.Fragment key={g.key.join('.')}>
                              <Text>
                                <strong>{g.label}: </strong>
                                {Array.isArray(value)
                                  ? value.join(', ')
                                  : value}
                              </Text>
                              <br />
                            </React.Fragment>
                          )
                        })}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                ))}
              </React.Fragment>
            ))
          )}
          {/* </Space> */}
        </Card>
      ) : (
        <Card
          style={{ width: '100%' }}
          title={
            isCollection
              ? `Fixed SKU: ${
                  resolveProductName(get(product, 'orderCollection.productName')) ||
                  get(productDetails, 'data.name.en', '')
                }`
              : isFixedDesign
              ? `Fixed Design: ${
                  resolveProductName(get(product, 'orderFixedDesign.productName'))
                }`
              : prodForms?.name
          }
          tabList={
            [
              { key: '0', tab: 'Option' },
              { key: '1', tab: 'Measurement', disabled: !formsInf },
            ]
          }
          activeTabKey={selectedMeasure}
          onTabChange={setSelectedMeasure}
        >
          {/* {console.log(formsInf, product)} */}
          {selectedMeasure === '0' ? (
            product.orderProductType === 'collection' ? (
              <CollectionSizeOrOptions product={product} />
            ) : product.orderProductType === 'fixed_design' ? (
              <>
                {get(product, 'orderFixedDesign.description') && (
                  <>
                    <Text>
                      <strong>Description: </strong>
                      {get(product, 'orderFixedDesign.description.en', '') ||
                        get(product, 'orderFixedDesign.description.zh', '')}
                    </Text>
                    <br />
                  </>
                )}
                {get(product, 'orderFixedDesign.selectedOptions', []).length >
                0 ? (
                  get(product, 'orderFixedDesign.selectedOptions', []).map(
                    (option, i) => (
                      <React.Fragment key={i}>
                        <Text>
                          <strong>
                            {option?.optionName?.en || option?.optionName?.zh}:{' '}
                          </strong>
                          {option?.freeFieldValue ||
                            option?.subOptionName?.en ||
                            option?.subOptionName?.zh}
                        </Text>
                        <br />
                      </React.Fragment>
                    )
                  )
                ) : (
                  <Text>No Options</Text>
                )}
              </>
            ) : (
              <OptionDisplay formsInf={formsInfF} product={product} />
            )
          ) : (
            formsInf.map((forms, formsIdx) => (
              <React.Fragment key={forms.key ?? `forms-${formsIdx}`}>
                {forms.form.map((e, eIdx) => (
                  <React.Fragment key={e.display ?? `e-${eIdx}`}>
                    <Title level={5}>{e.display}:</Title>
                    {/* Show size preset metadata if present (unvalidated orders, single measurement) */}
                    {(() => {
                      const measKey = forms.key
                      const meta = get(
                        product,
                        `${measKey}.__sizePresetMeta`,
                        null
                      )
                      if (!meta || !meta.presetName || !meta.sizeName) return null
                      return (
                        <>
                          <Text>
                            <strong>Preset size: </strong>
                            {meta.presetName} – {meta.sizeName}
                          </Text>
                          <br />
                        </>
                      )
                    })()}
                    {e.sections.map((f, fIdx) => (
                      <React.Fragment key={f.key?.join('.') ?? fIdx}>
                        {f.fields.map((g) => {
                          const fullPath = `${forms.key}.${g.key.join('.')}`
                          const value = get(product, fullPath, '')

                          if (!g.label) return null

                          const isTrialSamplePicture =
                            g.key.join('.') === 'trialSamplePicture'

                          if (typeof value === 'object' && !isTrialSamplePicture)
                            return null

                          if (
                            (g.isHiding &&
                              g.isHiding(product, `${forms.key}.`, true)) ||
                            (!value && value !== 0)
                          ) {
                            return null
                          }

                          if (isTrialSamplePicture) {
                            const pics = Array.isArray(value) ? value : []
                            if (!pics.length) return null

                            return (
                              <React.Fragment key={g.key.join('.')}>
                                <Text>
                                  <strong>{g.label}: </strong>
                                </Text>
                                <br />
                                <Space wrap style={{ marginBottom: 8 }}>
                                  {pics.map((pic, idx) => (
                                    <Image
                                      key={idx}
                                      height={100}
                                      src={`${process.env.REACT_APP_API_URL}/storage/order-trial-sample/${pic.uri}`}
                                    />
                                  ))}
                                </Space>
                                <br />
                              </React.Fragment>
                            )
                          }

                          return (
                            <React.Fragment key={g.key.join('.')}>
                              <Text>
                                <strong>{g.label}: </strong>
                                {Array.isArray(value)
                                  ? value.join(', ')
                                  : value}
                              </Text>
                              <br />
                            </React.Fragment>
                          )
                        })}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                ))}
              </React.Fragment>
            ))
          )}
        </Card>
      )}
      <Card style={{ width: '100%', marginTop: -1 }}>
        <Space direction="vertical">
          <Text type="secondary">Personae Type</Text>
          <Text strong>
            {isFixedDesign
              ? get(product, `orderFixedDesign.personaeType`, null)
              : isCollection
              ? get(product, `orderCollection.personaeType`, null)
              : get(product, `orderCustom.personaeType`, null)}
          </Text>
        </Space>
      </Card>
      {(get(product, `fabricRefPictures`) || []).length > 0 && (
        <Card style={{ width: '100%', marginTop: -1 }} title="Fabric reference pictures">
          <Space wrap>
            {(get(product, `fabricRefPictures`) || []).map((pic, idx) => (
              <Image
                key={idx}
                height={100}
                src={`${process.env.REACT_APP_API_URL}/storage/order-fabric-ref/${pic.uri}`}
              />
            ))}
          </Space>
        </Card>
      )}
      <Card style={{ width: '100%', marginTop: -1 }}>
        <Space direction="vertical">
          <Text type="secondary">QTY: {getQty()}</Text>
          <Text strong>
            {symbol}
            {calcTotal()}
          </Text>

          <Space>
            <Select
              value={get(product, 'completionStatus', 'in_production')}
              style={{ width: 180 }}
              onChange={(value) =>
                onCompletionStatusChange(
                  get(product, '_id'),
                  get(product, 'completionStatus', 'in_production'),
                  value
                )
              }
            >
              <Select.Option value="in_production">In production</Select.Option>
              <Select.Option value="given_to_client">Given to client</Select.Option>
              <Select.Option value="ready_to_pick_up">Ready to pick up</Select.Option>
            </Select>
          </Space>

          {orderDetails?.orderType !== 'fast_sale' && (
            <Space>
              <Button
                disabled={!formsInf && selectedMeasure === '1'}
                type="primary"
                onClick={() => measureSelected(product.index, selectedMeasure)}
              >
                Modify
              </Button>
            </Space>
          )}
        </Space>
      </Card>
    </>
  )
}

/** Shows size (new fix-sku) or options (legacy) for collection products */

const Detail = ({ data, editMeasure, validate }) => {
  const clientDetails = useQuery(
    [
      'getClientDetails',
      {
        id: get(data, 'customer', ''),
      },
    ],
    getClientDetails,
    {
      refetchOnWindowFocus: false,
      enabled: !!get(data, 'customer', ''),
    }
  )

  const [isExporting, setIsExporting] = useState(false)

  const completionStatusMutation = useMutation(
    ({ productId, completionStatus }) =>
      updateProductCompletionStatus(data.id, productId, completionStatus),
    { onSuccess: () => window.location.reload() }
  )

  const STATUS_LABELS = {
    in_production: 'In production',
    given_to_client: 'Given to client',
    ready_to_pick_up: 'Ready to pick up',
  }

  const handleCompletionStatusChange = (productId, currentStatus, newStatus) => {
    Modal.confirm({
      title: 'Update completion status',
      content: `Change status from "${STATUS_LABELS[currentStatus] ?? currentStatus}" to "${STATUS_LABELS[newStatus] ?? newStatus}"?`,
      okText: 'Confirm',
      cancelText: 'Cancel',
      onOk: () => completionStatusMutation.mutate({ productId, completionStatus: newStatus }),
    })
  }

  const validation = useMutation(
    () => updateOrder({ ...data, validated: true }, data.id),
    {
      onSuccess: validate,
    }
  )

  const exportOrder = (data) => {
    setIsExporting(true)
    getOrderExcel(get(data, 'id', ''))
      .then((file) => {
        const url = window.URL.createObjectURL(new Blob([file]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `Order-${get(data, 'orderID', 'order')}-${get(
            clientDetails,
            'data.firstName',
            ''
          )} ${get(clientDetails, 'data.lastName', '')}.xlsx`
        )
        document.body.appendChild(link)
        link.click()
      })
      .catch((error) => {
        console.log('error', error)
        alert(`An error occurred while exporting the order`)
      })
      .finally(() => {
        setIsExporting(false)
      })
  }

  const exportAdjustment = (data) => {
    setIsExporting(true)
    getAdjustmentExcel(get(data, 'id', ''))
      .then((file) => {
        const url = window.URL.createObjectURL(new Blob([file]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `Order-${get(data, 'orderID', 'order')}-${get(
            clientDetails,
            'data.firstName',
            ''
          )} ${get(clientDetails, 'data.lastName', '')}.xlsx`
        )
        document.body.appendChild(link)
        link.click()
      })
      .catch((error) => {
        console.log('error', error)
        alert(`An error occurred while exporting the order`)
      })
      .finally(() => {
        setIsExporting(false)
      })
  }

  return (
    <Space
      className="detail-general-order"
      direction="vertical"
      style={{ width: '100%', padding: '0px 24px' }}
    >
      <Card title="General information">
        <StyleForm component="div" layout="vertical" style={{ width: '100%' }}>
          <Space direction="vertical" style={{ width: '100%' }} size="large">
            <Space direction="vertical" style={{ width: '100%' }} size="small">
              <Text>Order ID: {get(data, 'orderID', '')}</Text>
              <Text>
                Order date: {moment(get(data, 'date', '')).format('DD/MM/yyyy')}
                {/* Order date: {moment().format('MMMM Do YYYY, h:mm:ss a')} */}
              </Text>
              <Text>Channel: {get(data, 'channel', '')}</Text>
              {get(data, 'channel') === 'store' && get(data, 'store') && (
                <Text>
                  Store:{' '}
                  {get(data, 'store.name.en') ||
                    get(data, 'store.name.zh') ||
                    '—'}
                </Text>
              )}
              {get(data, 'createdBy') && (
                <Text>
                  Created by: {get(data, 'createdBy.name', '—')}
                </Text>
              )}
            </Space>

            <Space direction="vertical" size="small">
              <Text>
                Customer:{' '}
                {get(data, 'customer') ? (
                  <Link to={`/clients/${get(data, 'customer')}/view`}>
                    {get(clientDetails, 'data.firstName', '')}{' '}
                    {get(clientDetails, 'data.lastName', '')}
                  </Link>
                ) : (
                  '—'
                )}
              </Text>
              <Text>Comment: {get(data, 'address.comment', '')}</Text>
              <Text>
                Address: {get(data, 'address.address', '')}{' '}
                {get(data, 'address.area', '')}{' '}
                {get(data, 'address.zipCode', '')}{' '}
                {get(data, 'address.city', '')}
              </Text>
              <Text>Phone: {get(data, 'address.phone', '')}</Text>
            </Space>
            <Space direction="vertical" style={{ width: '100%' }} size="small">
              <StyleForm.Item label="Delivery status">
                <Select
                  style={{ width: '33%' }}
                  defaultValue={data?.status}
                  disabled={true}
                  // onChange={handleChange}
                >
                  <Select.Option value="in_preparation">
                    In preparation
                  </Select.Option>
                  <Select.Option value="in_production">
                    In production
                  </Select.Option>
                  <Select.Option value="on_the_way_store">
                    On the way to store
                  </Select.Option>
                  <Select.Option value="on_the_way_client">
                    On the way to client
                  </Select.Option>
                  <Select.Option value="ready_to_pick_up">
                    Ready to pick up
                  </Select.Option>
                  <Select.Option value="order_finished">
                    Order finished
                  </Select.Option>
                  <Select.Option value="cancelled">Cancelled</Select.Option>
                </Select>
              </StyleForm.Item>

              <StyleForm.Item label="Deliver in store">
                <Radio.Group
                  style={{ width: '33%' }}
                  defaultValue="yes"
                  disabled={true}
                >
                  <Radio value="yes">Yes</Radio>
                  <Radio value="no">No</Radio>
                </Radio.Group>
              </StyleForm.Item>
              {/* <StyleForm.Item label="Persona type">
                <Radio.Group
                  style={{ width: '33%' }}
                  defaultValue={data?.personaeType}
                  disabled={true}
                >
                  <Radio value="special_event">Special event</Radio>
                  <Radio value="wardrobe_update">Wardrobe update</Radio>
                </Radio.Group>
              </StyleForm.Item> */}
            </Space>
            {get(data, 'orderProducts').findIndex(
              (e) => e.orderProductType === 'adjustment'
            ) === -1 &&
              get(data, 'orderType') !== 'fast_sale' && (
              <Space>
                {get(data, 'orderType') !== 'fast_sale' && (
                  <Button
                    disabled={
                      clientDetails.isLoading ||
                      !data ||
                      get(data, 'validated', false)
                    }
                    loading={validation.isLoading}
                    onClick={() => validation.mutate()}
                    type="primary"
                  >
                    Start production
                  </Button>
                )}
                <Button
                  loading={isExporting}
                  disabled={
                    isExporting ||
                    clientDetails.isLoading ||
                    !data ||
                    (get(data, 'orderType') !== 'fast_sale' &&
                      !get(data, 'validated', false))
                  }
                  onClick={() => exportOrder(data)}
                  type="primary"
                >
                  Export Excel
                </Button>
              </Space>
            )}
            {get(data, 'orderProducts').findIndex(
              (e) => e.orderProductType === 'adjustment'
            ) === 0 && (
              <Space>
                <Button
                  disabled={clientDetails.isLoading || !data}
                  onClick={() => exportAdjustment(data)}
                  type="primary"
                >
                  Export Excel
                </Button>
              </Space>
            )}
          </Space>
        </StyleForm>
      </Card>
      {data.orderProducts
        .map((prod, index) => {
          const prodType = getFromKey(prod)
          return {
            ...prod,
            index,
            priority: PRIORITY_MAP[prodType],
          }
        })
        .sort((a, b) => b.priority - a.priority)
        .map((prod) =>
          prod.orderProductType === 'adjustment' ? (
            <AdjustmentCard
              key={prod.index}
              product={prod}
              prodIndex={prod.index}
              measureSelected={() => editMeasure(prod.index)}
              orderIDClean={get(data, 'orderID', '')}
              validated={get(data, 'validated', false)}
              onCompletionStatusChange={handleCompletionStatusChange}
            />
          ) : (
            <MeasureCard
              key={prod.index}
              product={prod}
              prodIndex={prod.index}
              measureSelected={editMeasure}
              orderIDClean={get(data, 'orderID', '')}
              validated={get(data, 'validated', false)}
              orderDetails={data}
              onCompletionStatusChange={handleCompletionStatusChange}
            />
          )
        )}
    </Space>
  )
}


export default Detail
